import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesReleaseNotes} from '/redux/selector/remoteConfig.selector';

import {ReleaseNotes as ReleaseNotesComponent} from './ReleaseNotes';

export default connect(
  createStructuredSelector({
    releaseNotes: variablesReleaseNotes,
  }),
)(ReleaseNotesComponent);
